import React from 'react'
import cardService from '../Service/cardService'
import { Modal } from 'react-bootstrap'
import { config } from '../Config/config'
import ModalTambahKartu from './modalTambahKartu'
import profileService from '../Service/profileService'
import walletService from '../Service/walletService'
import AktifDompet from './aktifDompet'
import IsiSaldo from './isiSaldo'
import Konfirmasi from './konfirm'


export default class index extends React.Component {

    cardModel = {
        customer_id: localStorage.getItem(config.userid),
        card_number: "",
        validity_period: "",
        cvv: "",
        create_by: "",
        create_on: "",
        modified_by: "",
        modified_on: "",
        deleted_by: "",
        deleted_on: "",
        is_delete: false
    }
    constructor() {
        super()
        this.state = {
            List: [],
            ListCount: [],
            kadaluarsa: false,
            Model: this.cardModel,
            showModal: false,
            showModalAdd: false,
            showKonfirm: false,
            showModalDel: false,
            showModalDel2: false,
            errors: {},
            filter: {
                customer_id: localStorage.getItem(config.userid)
            },
            d: new Date(),
            //Saldo dan Dompet
            List_user: [],
            List_biodata: [],
            status: "Aktifkan",
            status_wallet: "",
            setShowAktivasi: false,
            disabled: true,
            opacity: "",
            pointerEvents: "",
            setShowPin: false,
            setShowSaldo: false,
            pin: "",
            amount: "",
            balance: "0",
            nominal: [],
            def_nom: [],
            other_balance: "0",
            hide: "none",
            Wallet: {}
        }
    }

    loadList = async () => {
        const respon = await cardService.getAllFilter(this.state.filter)
        const responCount = await cardService.countData(this.state.filter)
        const responUser = await profileService.getBio(localStorage.getItem(config.userid))
        const responWalet = await walletService.getAll(localStorage.getItem(config.userid))
        const responNominal = await walletService.getNominal(localStorage.getItem(config.userid))
        const respomDefault = await walletService.getDefaultNom()
        console.log(respomDefault)
        // console.log(responCount)
        if (respon.success) {
            this.setState({
                List: respon.result,
                List_user: responUser.result,
                List_biodata: responUser.result.user_biodata[0],
                nominal: responNominal.result,
                def_nom: respomDefault.result,
                List: respon.result
            })

            {
                this.state.List.map(data => {
                    this.setState({
                        kadaluarsa: data.kadaluarsa
                    })
                })
            }


            if (responCount.result != undefined) {
                this.setState({
                    ListCount: responCount.result
                })
            }
            if (responWalet.result != undefined) {
                this.setState({
                    Wallet: responWalet.result,
                }, () => {
                    if (this.state.Wallet.is_delete == true) {
                        this.setState({
                            opacity: "0.25",
                            pointerEvents: "none",
                            disabled: true,
                            status: "Aktifkan",
                            amount: "Belum Aktif"
                        })
                    } else if (this.state.Wallet.is_delete == false) {
                        this.setState({
                            opacity: "1",
                            pointerEvents: "auto",
                            disabled: false,
                            status: "Tutup",
                            amount: "Rp." + parseFloat(this.state.Wallet.balance).toLocaleString('en'),
                        })
                    }
                })
            }
        }
        // console.log(this.List)
    }

    componentDidMount() {
        this.loadList()
    }

    createHandler = () => {
        let jumlah = 0
        if (this.state.ListCount.count != undefined) {
            jumlah = this.state.ListCount.count
        }
        // console.log("jumlah = " + jumlah)
        if (jumlah != 4) {
            this.setState({
                showModal: true,
                Model: this.cardModel
            })
        } else {
            // alert("Jumlah kartu sudah mencapai jumlah maksimal")
            this.setState({
                showKonfirm: true
            })
        }
    }

    cancelHandler = () => {
        this.setState({
            showModal: false,
            showKonfirm: false,
            errors: {}
        })
    }

    cancelHandlerDel = () => {
        this.setState({
            showModalDel: false
        })
    }

    cancelHandlerDel2 = () => {
        this.setState({
            showModalDel2: false,
            showModalAdd: false
        })
    }


    changeHandler = field => ({ target: { value } }) => {
        this.setState({
            Model: {
                ...this.state.Model,
                [field]: value
            }
        })
    }

    saveHandler = async () => {
        const responCard = await cardService.dupeDataCard(this.state.Model.card_number)
        var card_number = ""

        if (responCard.result != undefined) {
            card_number = responCard.result.card_number
        }

        console.log(card_number)


        if (this.handleValidation(card_number)) {
            const respon = await cardService.addData(this.state.Model)
            console.log(respon)
            if (respon.success) {
                this.loadList()
                this.setState({
                    Model: this.cardModel,
                    showModal: false,
                    showModalAdd: true
                })

            }
        }
    }


    softDeleteHandler = async (id) => {
        const respon = await cardService.getById(id)
        this.setState({
            showModalDel: true
        })
        if (respon.success) {
            this.setState({
                Model: respon.result
            })
        }
    }

    saveHandlerDel = async () => {
        const respon = await cardService.softDeleteData(this.state.Model)
        console.log(respon)
        if (respon.success) {
            await this.loadList()
            this.setState({
                Model: this.cardModel,
                showModalDel: false,
                showModalDel2: true
            })
        }

    }

    filterHandler = field => ({ target: { value } }) => {
        this.setState({
            filter: {
                ...this.state.filter,
                [field]: value
            }
        })
    }

    handleValidation(cekCard) {
        let fields = this.state.Model
        let errors = {}
        let formIsValid = true;

        //get month and year now
        var monthNow = this.state.d.getMonth() + 1
        var year = this.state.d.getFullYear()

        //convert year to string
        var yearStr = year.toString().substr(2, 2)

        //convert year to int
        var yearNow = parseInt(yearStr)


        //get month and year input
        var monthValid = fields["validity_period"].substr(5, 2)
        var yearValid = fields["validity_period"].substr(2, 2)


        var monthInt = parseInt(monthValid)
        var yearInt = parseInt(yearValid)


        console.log(cekCard)
        console.log(monthNow)
        console.log(yearNow)
        console.log(monthInt)
        console.log(yearInt)

        if (cekCard) {
            formIsValid = false
            errors["card"] = "Card is already taken"
        }

        if (!fields["card_number"]) {
            formIsValid = false
            errors["card"] = "Card Number cannot be empty"
        }

        if (isNaN(fields["card_number"])) {
            formIsValid = false
            errors["card"] = "Card Number must be number"

        }

        if (!fields["validity_period"]) {
            formIsValid = false
            errors["validity_period"] = "Vailidity Period cannot be empty"
        }


        if (!fields["cvv"]) {
            formIsValid = false
            errors["cvv"] = "CVV cannot be empty"
        }

        if (isNaN(fields["cvv"])) {
            formIsValid = false
            errors["cvv"] = "CVV must be number"
        }

        if (yearNow == yearInt) {
            if (monthInt < monthNow) {
                formIsValid = false
                errors["validity_period"] = "Card expired"
            }
        }

        if (yearNow > yearInt) {
            formIsValid = false
            errors["validity_period"] = "Card expired"
        }

        console.log(fields["validity_period"])





        this.setState({ errors: errors })
        return formIsValid
    }
    //============================================
    //============================================
    //Isi dan aktivasi

    changeAktif = () => {
        this.setState({
            setShowAktivasi: true
        })
    }
    cancelAktif = () => {
        this.setState({
            setShowAktivasi: false
        })
    }

    cekpin = () => {
        this.setState({
            setShowPin: true,
            setShowAktivasi: false
        })
    }

    cancelpin = () => {
        this.setState({
            setShowPin: false,
            pin: "",
            errors: ""
        })
    }


    changehandlerpin = name => ({ target: { value } }) => (
        this.setState({
            [name]: value
        })
    )

    pinValidation = async () => {
        let errors = {}
        let formIsValid = true

        if (this.state.Wallet.pin != undefined) {
            if (this.state.pin != this.state.Wallet.pin) {
                formIsValid = false;
                errors["pin"] = "Wrong pin";
            }
            else if (this.state.pin == this.state.Wallet.pin) {
                formIsValid = true;
                this.setState({
                    errors: ""
                })
            }
            this.setState({
                errors: errors,
            })
            return formIsValid
        }
    }

    pinVerification = async () => {
        let x = this.state.Wallet.pin
        if (x == undefined) {
            const responIn = await walletService.insertWallet({ customer_id: localStorage.getItem(config.userid), pin: this.state.pin })
            if (responIn.success) {
                window.location.reload()
            }
        } else if (this.pinValidation()) {
            const respon = await walletService.aktifWallet(this.state.Wallet)
            if (respon.success) {
                this.setState({
                    setShowPin: false
                })
                this.loadList()
                window.location = "/profile"
            }
        }
    }

    changeSaldo = () => {
        this.setState({
            setShowSaldo: true
        })
    }
    cancelSaldo = () => {
        this.setState({
            setShowSaldo: false,
            balance: "",
            hide: "none",
            other_balance: "",
            errors: ""
        })
    }

    otherShow = () => {
        if (this.state.balance == "others") {
            this.setState({
                hide: "block"
            })
        } else {
            this.setState({
                hide: "none"
            })
        }
    }

    balanceValidation = () => {
        let errors = {}
        let formIsValid = true
        if (this.state.balance == "0" && this.state.other_balance == "0") {
            formIsValid = false;
            errors["balance"] = "Cannot Empty";
        } else if (this.state.balance == "others" && this.state.other_balance == "0") {
            formIsValid = false;
            errors["other_balance"] = "Cannot Empty";
        } else if (this.state.balance == "others" && parseInt(this.state.other_balance) <= 10000) {
            formIsValid = false;
            errors["other_balance"] = "Minimum top up is 10000";
        } else {
            formIsValid = true;
        }

        this.setState({
            errors: errors,
        })
        return formIsValid
    }

    updBalance = async () => {
        if (this.balanceValidation()) {
            if (this.state.balance == "others") {
                let bodyupd = {
                    id_wallet: this.state.Wallet._id,
                    customer_id: localStorage.getItem(config.userid),
                    balance: parseInt(this.state.other_balance) + parseInt(this.state.Wallet.balance),
                    other_balance: this.state.other_balance
                }
                const responUpd = await walletService.updWallet(bodyupd)
                const responInsNom = await walletService.insCustNom(bodyupd)
                const responInsTopUp = await walletService.instTopUp(bodyupd)
                if (responUpd.success) {
                    this.loadList()
                    this.setState({
                        balance: "",
                        other_balance: "",
                        setShowSaldo: false,
                        errors: ""
                    })
                    window.location = '/profile'
                }
            } else if (this.state.balance != "others") {
                let bodyupd = {
                    id_wallet: this.state.Wallet._id,
                    customer_id: localStorage.getItem(config.userid),
                    balance: parseInt(this.state.balance) + parseInt(this.state.Wallet.balance),
                    other_balance: this.state.balance
                }
                const responUpd = await walletService.updWallet(bodyupd)
                const responInsTopUp = await walletService.instTopUp(bodyupd)
                if (responUpd.success) {
                    this.loadList()
                    this.setState({
                        balance: "",
                        other_balance: "",
                        setShowSaldo: false,
                        errors: ""
                    })
                    window.location = '/profile'
                }
            }
        }
    }

    render() {
        const { List, Model, showModal, showModalAdd, showModalDel, showModalDel2, errors, ListCount, d,
            //=============================================================
            //Saldo dan Dompet
            status, opacity, pointerEvents, disabled, setShowAktivasi, Wallet,
            setShowPin, pin, amount, balance, setShowSaldo,
            nominal, other_balance, hide, showKonfirm, def_nom

            //=============================================================
        } = this.state
        // const { List, Model, showModal, showModalDel, errors, ListCount } = this.state
        return (
            <div class="tab-pane show" id="about-cont">
                {/* {JSON.stringify(ListCount)} */}

                <div class="card-box" >
                    <div class="card-box" style={{ border: "solid lightBlue" }}>
                        <div class="form-group">
                            <div class="row">
                                <div class="col-6">
                                    <h5 style={{ color: "black" }}>Kartu Kredit/Debit ({ListCount.count}/4 tersimpan)</h5>
                                </div>
                                <div class="col-6">
                                    <button class="btn btn-primary float-right" onClick={this.createHandler}> + Tambah</button>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            {
                                List.map(data => {
                                    if (data.first_card == 4) {
                                        return (
                                            <div>
                                                <div class="row">

                                                    <div class="col-md-4">
                                                        <h5>xxxx xxxx xxxx {data.card_number}</h5>
                                                        <div class="col-md-4">
                                                            <h6>{data.tanggal}</h6>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-2">
                                                        <img class="img-circle" style={{ width: 50 }} src="assets/img/masterCard.png" alt="" />
                                                    </div>

                                                    <div class="col-md-2">
                                                        <div class="row">
                                                            <div class="col-md-2">
                                                                <button class="border-0" onClick={() => this.softDeleteHandler(data._id)}><i class="fa fa-trash"></i></button>
                                                            </div>

                                                            <div class="col-md-2">
                                                                <label style={{ color: "black" }}>Hapus</label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* <div class="col-4">
                                                    <img class="avatar mt-2 ml-1" src="assets/img/masterCard.png" alt="" />
                                                </div>
    
                                                <div class="col-4">
                                                    <button onClick={() => this.softDeleteHandler(data._id)}>Hapus</button>
                                                </div> */}
                                                </div>

                                            </div>
                                        )
                                    } else {
                                        return (
                                            <div>
                                                <div class="row">

                                                    <div class="col-md-4">
                                                        <h5>xxxx xxxx xxxx {data.card_number}</h5>
                                                        <div class="col-md-4">
                                                            <h6>{data.tanggal}</h6>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-2">
                                                        <img class="img-circle" style={{ width: 50 }} src="assets/img/iconfinder_363_Visa_Credit_Card_logo_4375165.png" alt="" />
                                                    </div>

                                                    <div class="col-md-2">
                                                        <div class="row">
                                                            <div class="col-md-2">
                                                                <button class="border-0" onClick={() => this.softDeleteHandler(data._id)}><i class="fa fa-trash"></i></button>
                                                            </div>

                                                            <div class="col-md-2">
                                                                <label style={{ color: "black" }}>Hapus</label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* <div class="col-4">
                                                    <img class="avatar mt-2 ml-1" src="assets/img/masterCard.png" alt="" />
                                                </div>
    
                                                <div class="col-4">
                                                    <button onClick={() => this.softDeleteHandler(data._id)}>Hapus</button>
                                                </div> */}
                                                </div>

                                            </div>
                                        )
                                    }

                                })
                            }
                        </div>
                    </div>
                </div>
                <div class="card-box">

                    <div class="row">
                        <div class="col-md-4">
                            <h4 class="float-left" style={{ color: "blue" }}>Dompet Sehat</h4>
                        </div>
                        <div class="col-md-8">
                            <button class="btn btn-primary float-right" style={{ margin: "0 5px" }} onClick={this.changeAktif}>{status}</button>
                            <button class="btn btn-primary float-right " style={{ margin: "0 5px", opacity: { opacity }, pointerEvents: { pointerEvents } }} disabled={disabled} >Atur PIN</button>
                            <button class="btn btn-primary float-right " style={{ margin: "0 5px", opacity: { opacity }, pointerEvents: { pointerEvents } }} disabled={disabled} onClick={this.changeSaldo}>Isi Saldo</button>

                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <h1 class="float-left" style={{ color: "blue" }}>{amount}</h1>
                        </div>
                        <div class="col-md-6">
                        </div>
                    </div>
                </div>
                <ModalTambahKartu
                    List={List}
                    Model={Model}
                    showModal={showModal}
                    showModalAdd={showModalAdd}
                    showModalDel={showModalDel}
                    showModalDel2={showModalDel2}
                    errors={errors}
                    cancelHandler={this.cancelHandler}
                    cancelHandlerDel={this.cancelHandlerDel}
                    cancelHandlerDel2={this.cancelHandlerDel2}
                    changeHandler={this.changeHandler}
                    saveHandler={this.saveHandler}
                    d={d}
                    saveHandlerDel={this.saveHandlerDel}

                />
                <AktifDompet
                    setShowAktivasi={setShowAktivasi}
                    setShowPin={setShowPin}
                    Wallet={Wallet}
                    pin={pin}
                    status={status}
                    pinValidation={this.pinValidation}
                    pinVerification={this.pinVerification}
                    changehandlerpin={this.changehandlerpin}
                    cekpin={this.cekpin}
                    cancelAktif={this.cancelAktif}
                    cancelpin={this.cancelpin}
                    errors={errors}
                />
                <IsiSaldo
                    balance={balance}
                    nominal={nominal}
                    def_nom={def_nom}
                    hide={hide}
                    other_balance={other_balance}
                    setShowSaldo={setShowSaldo}
                    updBalance={this.updBalance}
                    otherShow={this.otherShow}
                    changehandlerpin={this.changehandlerpin}
                    cancelSaldo={this.cancelSaldo}
                    errors={errors} />
                <Konfirmasi
                    showKonfirm={showKonfirm}
                    cancelHandler={this.cancelHandler}
                />
            </div>

        )
    }
}